import { PageHeading } from 'components/atoms';
import { Head, PageLayout } from 'components/molecules';
import { getTranslations } from 'i18n';
import type { GetStaticProps, NextPage } from 'next';
import React, { Fragment } from 'react';
import { useTranslation } from 'utils/hooks';
import { TranslationKey } from 'utils/hooks/useTranslation';

const FaqPage: NextPage = () => 
{
  const { t, r } = useTranslation('faq');

  return (
    <PageLayout textContentPage>

      <Head title={t('faq:meta.title')}>
        <meta name="description" content={t('faq:meta.description')} />
        <meta name="keywords" content={t('faq:meta.keywords')} />
      </Head>

      <PageHeading title={t('faq:heading')} />

      {(t('faq:content', { returnObjects: true }) as string[]).map((_, index) => (
        <Fragment key={'faq' + index}>
          <h3>{t(`faq:content.${index}.title`)}</h3>
          <div>{r(`faq:content.${index}.text` as unknown as TranslationKey, {})}</div>
        </Fragment>
      ))}

    </PageLayout>
  );
};

export default FaqPage;

export const getStaticProps: GetStaticProps = async (ctx) =>
{
  const { locale } = ctx;
  const translations = await getTranslations(locale, 'faq');

  return { props: { ...translations } };
};
